import  { useState, useContext, useEffect, useRef } from "react";
import Song from "./song";
import { BookContent, Colour, FontType, UserAudios } from "../global";
import { Switch, Route, useHistory, useParams, useRouteMatch, useLocation } from "react-router-dom";
import { IonItem, IonToolbar, IonLabel, IonButtons, IonButton, IonPage, IonHeader, IonContent, isPlatform } from "@ionic/react";
import { ArrowBackSharp, MusicNote } from "@mui/icons-material";
import { AnimatePresence, motion } from "framer-motion";

function Sub(props) {
 let { songid } = useParams();
 let { path, url } = useRouteMatch();
 let location = useLocation();
 let id = Number(songid);
 let history = useHistory();
 const [clr, ] = useContext(Colour);
 const content = useContext(BookContent);
 const [font, ] = useContext(FontType);
 const [userAudios, ] = useContext(UserAudios)

 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 let colori,colorh;
 if(clr === "1") {
  colori = ""
  colorh = "primary"
 }
 if(clr === "2") {
  colori = "secondary"
  colorh = "warning"
 }
 if(clr === "3") {
  colori = "secondary"
  colorh = "success"
 }
 if(clr === "4") {
  colori = "secondary"
  colorh = "tertiary"
 }
 if(clr === "5") {
  colori = "dark"
  colorh = "warning"
 }
 if(clr === "6") {
  colori = "dark"
  colorh = "tertiary"
 }

 const [spos, setSpos] = useState(0);
 let locy = 0;
 const contentRef = useRef();
 useEffect(() => {
  if (location.pathname === url && contentRef.current) contentRef.current.scrollToPoint(0,spos);
 }, [location, contentRef.current]);

 return (
  <AnimatePresence onExitComplete>
   <Switch location={location}>
    <Route exact path={path}>
    <IonPage>
    
         <IonHeader>
     <IonToolbar color={colorh}>
      <IonButtons slot="start">
       <IonButton onClick={() => {
          if(history.length > 1){
            history.goBack()
          }else{
            history.push(url.slice(0, url.lastIndexOf("/")));
          }
       }}>
       <ArrowBackSharp style={{ fontSize: 30 }} />
       </IonButton>
      </IonButtons>
      <IonButtons slot="start">
       <IonLabel style={{ fontFamily: `${fon}` }}>
        {content[props.title].chap[id].name.indexOf("-") !== -1
         ? content[props.title].chap[id].name.slice(0, content[props.title].chap[id].name.indexOf("-"))
         : content[props.title].chap[id].name}
       </IonLabel>
      </IonButtons>
     </IonToolbar>
     </IonHeader>
     <IonContent onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori}>
         <div style={{ height: "2px" }}></div>
     <motion.div exit={{ opacity: 0 }} animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ type: "linear", duration: 1 }}>
      {content[props.title].chap[id].song.map((td, i) => {
       function next() {
        history.push(`${url}/${i}`);
       }
       return (
        <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
         <IonLabel style={{ fontFamily: `${fon}` }}>{td.name}</IonLabel>
         {td.vname || userAudios[td.name.slice(3)] ? <MusicNote style={{ fontSize: "23px" }} />: null}
        </IonItem>
       );
      })}
     </motion.div>
     </IonContent>
     </IonPage>
    </Route>
    <Route path={`${path}/:songid`}>
     <Song i1={props.title} i2={id} />
    </Route>
   </Switch>
  </AnimatePresence>
 );
}

export default Sub;
